import { render, staticRenderFns } from "./approve-deny-action.vue?vue&type=template&id=eec8d6b0"
import script from "./approve-deny-action.vue?vue&type=script&lang=js"
export * from "./approve-deny-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports